// Password Field
export const passwordRequired = 'กรุณากรอกรหัสผ่าน'
export const passwordMinLength = 'ขั้นต่ำ 8 อักษร'
export const newPasswordMismatch = 'รหัสผ่านใหม่ไม่ตรงกัน'
export const passwordMismatch = 'รหัสผ่านไม่ตรงกัน'
export const wrongPasswordError = "รหัสผ่านไม่ถูกต้อง"
export const showForgotPasswordError = 'รหัสผ่านไม่ถูกต้อง ต้องการรีเซ็ตรหัสผ่าน'
export const accountLockedError = 'บัญชีถูกล็อคเนื่องจากมีการกรอกรหัสผ่านไม่ถูกต้อง 10 ครั้งติดต่อกัน กรุณารีเซ็ตรหัสผ่าน'
export const wrongPasswordPattern = 'ความยาวอย่างน้อย 8 ตัว รวมภาษาอังกฤษตัวใหญ่ ตัวเล็ก ตัวเลข และอักขระพิเศษอย่างน้อย 1 ตัว'
export const oldPasswordDuplicated = 'รหัสผ่านที่กรอกตรงกับรหัสผ่านเก่าของคุณ กรุณาเลือกรหัสผ่านใหม่'

// Email Field
export const emailRequired = 'กรุณากรอกอีเมล'
export const emailMinLength = 'กรุณากรอกอีเมลให้ถูกต้อง'
export const emailWrongFormat = 'กรุณากรอกอีเมลให้ถูกต้อง'
export const userWithEmailExist = 'อีเมลนี้มีในระบบแล้ว'
export const userWithEmailNotExist = 'อีเมลนี้ไม่เคยเป็นสมาชิก Finnomena'
export const userAlreadyUsed = 'อีเมลนี้ถูกใช้แล้ว มีปัญหาการใช้งาน? ติดต่อเรา'
export const CHALLENGE_EXPIRED = 'เกินเวลาทำรายการที่กำหนด'

// OTP Field
export const OTP_REQUIRED = 'กรุณากรอกหมายเลข OTP'
export const ACTIVATED = 'ยืนยันอีเมลแล้ว'
export const INACTIVE = '( ยังไม่ยืนยันอีเมล )'

export const errorOccurred = 'เกิดความผิดพลาด'